import authInterceptor from "../AuthInterceptor";

export const OptimisationReviewAPI = {
  search: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/search/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  filter: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/filter/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  calculate: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/calculate/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  detail: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/detail/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  applyOptimisation: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/apply-optimisation/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  applyStatus: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/apply-status/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  applyAssignment: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/apply-assignment/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  applyJustification: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/apply-justification/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  downloadReport: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/report/`, bodyData, {
        responseType: "blob",
      })
      .then((response) => response)
      .catch((error) => Promise.reject(error)),

  downloadSavedReport: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/reports/download/`, bodyData, {
        responseType: "blob",
      })
      .then((response) => response)
      .catch((error) => Promise.reject(error)),

  listSavedReports: (bodyData) =>
    authInterceptor
      .post(`ranking-api/optimisation-review/reports/list/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  list: (config = {}) =>
    authInterceptor
      .get(`ranking-api/optimisation-review/list/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
};
